module.exports = __webpack_public_path__ + "img/nodejs-expressjs.bc0b0d7a.png";